module.exports = __webpack_public_path__ + "img/stats_icon.04677f4b.svg";